import styled from "styled-components"

const Div = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    .categorySelected {
        width: 210px;
        line-height: 20px;
        margin-top: ${ props => props.theme.spacing.main };
    }

    .elimination {
        color: var(--white, #FFF);
        text-align: center;
        font-family: var(--font-circular);
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: 140%; /* 19.6px */
        letter-spacing: 0.14px;
        text-transform: capitalize;
        margin-top: 65px;
        width: 230px;
    }

    .winner {
        font-size: 16px;
    }

    .winnerBalance {
        color: var(--yellow, #E6D2A6);
        text-align: center;
        font-family: var(--font-circular);
        font-size: 44px;
        font-style: normal;
        font-weight: 700;
        line-height: 110%; /* 48.4px */
        text-transform: capitalize;
        margin-top: 10px;
    }
`;

type Props = {
    children?: any
}

export const InfoScreen = ({ children }: Props) => {
    return (
        <Div>
            { children }
        </Div>
    )
}